<template>
  <div class="page-container">
    <!-- 展览列表 -->
    <van-list
      v-model="loading"
      :finished="finished"
      :immediate-check="false"
      finished-text="没有更多了"
      @load="getCurrentExhibitData"
    >
      <div v-if="firstData" class="header-item" @click="onClickItem(firstData)">
        <div class="img-wrap">
          <img :src="firstData.coverImage" />
        </div>
        <div class="title van-ellipsis">{{ firstData.title }}</div>
        <div class="info">
          <span class="time">{{ firstData.startDateTime }} ~ {{ firstData.endDateTime }}</span>
          <span class="place">{{ firstData.address }}</span>
        </div>
      </div>
      <div class="list">
        <div
          class="item"
          v-for="item in list.slice(1)"
          :key="item.id"
          @click="onClickItem(item)"
        >
          <img fit="cover" :src="item.coverImage" />
          <div class="info">
            <div class="title">{{ item.title }}</div>
            <div class="desc">
              <div>{{ item.startDateTime }} ~ {{ item.endDateTime }}</div>
              <div>{{ item.address }}</div>
            </div>
          </div>
        </div>
      </div>
    </van-list>
  </div>
</template>

<script>
import { getExhibitionList } from '@/api/exhibit'

export default {
  name: 'ExhibitCurrentIndex',
  data () {
    return {
      loading: false,
      finished: false,
      pageNo: 1,
      list: []
    }
  },
  computed: {
    firstData () {
      return this.list[0]
    }
  },
  created () {
    // 初始化加载数据
    this.getCurrentExhibitData()
  },
  methods: {
    getCurrentExhibitData () {
      if (this.finished || this.loading) return

      this.loading = true
      getExhibitionList({
        pageNo: this.pageNo,
        pageSize: 10
      })
        .then((res) => {
          if (res.success) {
            const { result } = res

            this.list = [...this.list, ...(result.records || [])]
            this.pageNo++
            this.finished = result.pages === 0 || result.current === result.pages
          }
        })
        .finally(() => {
          this.loading = false
        })
    },

    onClickItem (item) {
      this.$router.push(`/exhibitSwiperDitile/${item.id}`)
    }
  }
}
</script>

<style lang="scss" scoped>
@import "./index.scss";
</style>
